._itemsWrapper_1d7rg_1 {
  margin-right: auto;
  margin-left: auto; }

._items_1d7rg_1 {
  position: relative;
  overflow: hidden;
  width: 324px; }

._presetItemMargin_1d7rg_10 {
  margin-top: 29px; }
